<template>
  <v-container v-if="$store.getters.user" class="test_red mt-10">
    <v-row justify="center" no-gutters class="test_blue">
      <v-col cols="12" md="10" lg="8" class="test_yellow">
        <div class="list-item pt-5 pb-5">
          <div>
            <h2>{{ $t("customerProfile.password") }}</h2>
          </div>
          <div class="list-item-switch">
            <span class="subtitle" @click="show = true">
              {{ $t("customerProfile.change") }}
            </span>
          </div>
        </div>
        <div class="list-item">
          <div>
            <h2>{{ $t("customerProfile.smsCampaign") }}</h2>
          </div>
          <div class="list-item-switch">
            <v-switch
              v-model="isChecked"
              style="margin-right: -15px"
              color="primary"
              inset
              dense
              :value="0"
              :true-value="1"
              :false-value="0"
              @change="toggleSwitchSms"
            />
          </div>
        </div>
        <div class="list-item list-item-bottom">
          <div>
            <h2>{{ $t("customerProfile.emailCampaign") }}</h2>
          </div>
          <div class="list-item-switch">
            <v-switch
              v-model="isCheckedEmail"
              style="margin-right: -15px"
              color="primary"
              inset
              dense
              :value="0"
              :true-value="1"
              :false-value="0"
              @change="toggleSwitchEmail"
            />
          </div>
        </div>
        <div class="list-item pt-5 pb-5">
          <div>
            <h2>{{ $t("customerProfile.deleteAccount") }}</h2>
          </div>
          <div class="list-item-switch">
            <span class="subtitle-delete" @click="showDeleteModal = true">
              {{ $t("general.delete") }}
            </span>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="show"
      persistent
      max-width="550"
      transition="dialog-bottom-transition"
      content-class="dialog-rounded"
      :scrollable="false"
    >
      <ChangePasswordForm v-if="show" v-model="show" />
    </v-dialog>
    <v-dialog
      v-model="showDeleteModal"
      persistent
      max-width="550"
      transition="dialog-bottom-transition"
      content-class="dialog-rounded"
      :scrollable="false"
    >
      <card-modal>
        <template v-slot:header>
          <span
            class="title-modal-card"
            v-text="$t('customerProfile.deleteAccount')"
          />
          <v-spacer></v-spacer>
          <v-btn icon x-large @click="showDeleteModal = false">
            <v-icon x-large color="primary" v-text="'mdi-close'" />
          </v-btn>
        </template>
        <template v-slot:body>
          <div style="margin-top: 30px">
            <h3>{{ $t("customerProfile.deleteAccountDesc") }}</h3>
          </div>
        </template>
        <template v-slot:actions>
          <v-col>
            <ButtonCancel
              :title="$t('general.confirm')"
              @click="confirmDeleteAccount()"
            />
          </v-col>
        </template>
      </card-modal>
    </v-dialog>
  </v-container>
</template>

<script>
import ChangePasswordForm from "./ChangePasswordForm.vue";
import axios from "axios";
import ButtonCancel from "@/components/buttons/ButtonCancel.vue";
export default {
  name: "SettingsComponent",
  components: {
    ButtonCancel,
    ChangePasswordForm,
  },
  data: () => ({
    show: false,
    showDeleteModal: false,
    selected: null,
    isChecked: 0,
    isCheckedEmail: 0,
  }),
  watch: {
    show: function () {
      if (!this.show) {
        this.selected = null;
      }
    },
  },
  created() {
    this.isChecked = this.$store.getters.user.smsSubscriber;
    this.isCheckedEmail = this.$store.getters.user.emailSubscriber;
  },
  methods: {
    async confirmDeleteAccount() {
      try {
        await axios.post("/delete/account");
      } catch (e) {
        console.log(e);
      }
      this.showDeleteModal = false;
      this.$router.push({ path: "/" });
    },
    async toggleSwitchEmail() {
      try {
        await axios.post("/users/profiles/features/emailSubscribe");
      } catch (e) {
        console.log(e);
      }
    },
    async toggleSwitchSms() {
      try {
        await axios.post("/users/profiles/features/smsSubscribe");
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.list-group-item {
  height: 100%;
  border: solid;
  border-color: rgba($color: #aaa, $alpha: 0.5);
  border-width: 0.5px;
  cursor: pointer !important;
  border-radius: 10px;
}
.title {
  font-size: 1.5rem;
  font-family: $font_Bold;
}
.subtitle {
  font-size: 1.2rem;
  color: var(--v-primary-base) !important;
  cursor: pointer;
}
.subtitle-delete {
  font-size: 1.2rem;
  color: red !important;
  cursor: pointer;
}
.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ccc;
  //border-bottom: 1px solid #ccc;
  padding: 0 10px;
}
.list-item-bottom {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
.list-item-title {
  flex: 1;
}

.list-item-switch {
  margin-left: 10px;
}
</style>
